module.exports = __webpack_public_path__ + "static/add-wine-35b06f7b6201f6115cfdc9ebcbc2a4ba.mp4";